import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import tradies from './modules/tradies'
import businessAdmin from './modules/business-admin'
import notification from './modules/notification'
import report from './modules/report'
import versionControl from './modules/version-control'
import company from './modules/company'
import file from './modules/file'
import provider from './modules/provider'
import request from './modules/request'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    tradies,
    businessAdmin,
    notification,
    report,
    versionControl,
    company,
    file,
    provider,
    request
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
